import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-modal-custom-lock',
  templateUrl: './modal-custom-lock.component.html',
  styleUrls: ['./modal-custom-lock.component.scss']
})
export class ModalCustomLockComponent {
  public lockType: string = "default";
  public lockPwd: string = "";

  constructor(public dialogRef: MatDialogRef<ModalCustomLockComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {
    if (this.data.lockType && this.data?.lockType?.type != 'default') {
      this.lockType = this.data?.lockType.type
      this.lockPwd = this.data?.lockType.pwd
    }
  }

  setLock() {

    this.dialogRef.close({ type: this.lockType, pwd: this.lockPwd })
    console.log(this.lockType, this.lockPwd)
  }
}
